import React, { useState, useEffect } from "react";
import "./VistaUsuarios.css";

function DetalleRediseno({ usuario, alVolver }) {
  const [fotoActualIndex, setFotoActualIndex] = useState(0);
  const [fotoModalIndex, setFotoModalIndex] = useState(null);

  const fotos =
    Array.isArray(usuario?.fotos) && usuario.fotos.length > 0
      ? usuario.fotos
      : [usuario?.imagen || usuario?.photo_url || "/placeholder.jpg"];

  useEffect(() => {
    if (fotos.length <= 1) return;
    const timer = setInterval(() => {
      setFotoActualIndex((prevIndex) => (prevIndex + 1) % fotos.length);
    }, 3500);
    return () => clearInterval(timer);
  }, [fotos.length]);

  const serviciosArray = Array.isArray(usuario?.servicios)
    ? usuario.servicios
    : typeof usuario?.servicios === "string" && usuario.servicios.trim() !== ""
    ? usuario.servicios.split(",").map((s) => s.trim())
    : [];

  const precio30 = usuario?.precio_30min || usuario?.price_30min || "N/A";
  const precio1h = usuario?.precio_1hora || usuario?.price_1hour || "N/A";
  const precioNoche = usuario?.precio_noche || usuario?.price_night || "N/A";

  const estatura = usuario?.estatura || usuario?.height || "N/A";
  const cuerpo = usuario?.cuerpo || usuario?.body_type || "N/A";
  const cabello = usuario?.cabello || usuario?.hair_color || "N/A";
  const horario = usuario?.horario || usuario?.schedule || "N/A";
  const dias = usuario?.dias || usuario?.days || "N/A";
  const descripcion =
    usuario?.descripcion ||
    usuario?.description ||
    "Sin descripción disponible.";

  const idCamuflado = String(usuario?.id || "0").padStart(4, "0");

  const fotoAnterior = () =>
    setFotoActualIndex((prev) => (prev === 0 ? fotos.length - 1 : prev - 1));
  const fotoSiguiente = () =>
    setFotoActualIndex((prev) => (prev === fotos.length - 1 ? 0 : prev + 1));

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "480px",
        margin: "0 auto",
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
        color: "#0f172a",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        fontFamily: "system-ui, -apple-system, sans-serif",
        paddingBottom: "100px", // Margen inferior aumentado para que el scroll supere al botón
        position: "relative",
      }}
    >
      {/* 1. CONTENEDOR DE FOTO PRINCIPAL */}
      <div
        style={{
          position: "relative",
          width: "100%",
          aspectRatio: "4/5",
          maxHeight: "60vh",
          backgroundColor: "#e2e8f0",
          overflow: "hidden",
        }}
      >
        <img
          src={fotos[fotoActualIndex]}
          alt={usuario?.nic || usuario?.nombre}
          onClick={() => setFotoModalIndex(fotoActualIndex)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            cursor: "pointer",
            transition: "opacity 0.3s ease-in-out",
          }}
        />

        {fotos.length > 1 && (
          <>
            <button
              onClick={fotoAnterior}
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(0,0,0,0.4)",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                cursor: "pointer",
                fontSize: "1rem",
                zIndex: 5,
              }}
            >
              ❮
            </button>
            <button
              onClick={fotoSiguiente}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(0,0,0,0.4)",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                cursor: "pointer",
                fontSize: "1rem",
                zIndex: 5,
              }}
            >
              ❯
            </button>

            <div
              style={{
                position: "absolute",
                top: "16px",
                right: "16px",
                display: "flex",
                gap: "5px",
                zIndex: 5,
                background: "rgba(0,0,0,0.35)",
                backdropFilter: "blur(4px)",
                padding: "4px 8px",
                borderRadius: "12px",
              }}
            >
              {fotos.map((_, i) => (
                <span
                  key={i}
                  onClick={() => setFotoActualIndex(i)}
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor:
                      i === fotoActualIndex
                        ? "#e11d48"
                        : "rgba(255,255,255,0.6)",
                    cursor: "pointer",
                  }}
                />
              ))}
            </div>
          </>
        )}

        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            background:
              "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.85) 100%)",
            padding: "20px 16px 12px 16px",
            color: "#ffffff",
            textAlign: "center",
            pointerEvents: "none",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "1.35rem",
              fontWeight: "800",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#22c55e",
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>
            {usuario?.nic || usuario?.nombre},{" "}
            <span style={{ color: "#f43f5e" }}>
              {usuario?.edad || usuario?.age}
            </span>
            <span style={{ color: "#3b82f6", fontSize: "1.1rem" }}>✓</span>
          </h2>

          <p
            style={{
              margin: "4px 0 0 0",
              fontSize: "0.8rem",
              color: "#cbd5e1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
            }}
          >
            ID: {idCamuflado} &nbsp;|&nbsp;
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="currentColor"
              style={{
                color: "#f43f5e",
                display: "inline-block",
                verticalAlign: "middle",
              }}
            >
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
            </svg>
            {usuario?.ubicacion || usuario?.location || "Santa Cruz"}
          </p>
        </div>
      </div>

      {/* 2. BARRA DE ACCIÓN */}
      <div
        style={{
          padding: "12px 16px",
          backgroundColor: "#ffffff",
          borderBottom: "1px solid #e2e8f0",
          display: "flex",
          alignItems: "center",
        }}
      >
        <a
          href={`https://wa.me/591${
            usuario?.telefono || usuario?.phone
          }?text=Hola%20${encodeURIComponent(usuario?.nic || usuario?.nombre)}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: "100%",
            backgroundColor: "#25d366",
            color: "#ffffff",
            padding: "11px 16px",
            borderRadius: "10px",
            fontWeight: "700",
            fontSize: "0.95rem",
            textAlign: "center",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            boxShadow: "0 2px 8px rgba(37, 211, 102, 0.25)",
            transition: "background-color 0.2s",
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.124-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
          </svg>
          Contactar por WhatsApp
        </a>
      </div>

      {/* 3. SECCIONES DE INFORMACIÓN */}
      <div
        style={{
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {/* Tarifas */}
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "14px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <h4
            style={{
              margin: "0 0 8px 0",
              fontSize: "0.8rem",
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Tarifas
          </h4>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "8px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                background: "#f8fafc",
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #f1f5f9",
              }}
            >
              <div style={{ fontSize: "0.7rem", color: "#64748b" }}>30 Min</div>
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "0.9rem",
                  color: "#0f172a",
                }}
              >
                Bs. {precio30}
              </div>
            </div>
            <div
              style={{
                background: "#f8fafc",
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #f1f5f9",
              }}
            >
              <div style={{ fontSize: "0.7rem", color: "#64748b" }}>1 Hora</div>
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "0.9rem",
                  color: "#0f172a",
                }}
              >
                Bs. {precio1h}
              </div>
            </div>
            <div
              style={{
                background: "#f8fafc",
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #f1f5f9",
              }}
            >
              <div style={{ fontSize: "0.7rem", color: "#64748b" }}>Noche</div>
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "0.9rem",
                  color: "#0f172a",
                }}
              >
                Bs. {precioNoche}
              </div>
            </div>
          </div>
        </div>

        {/* Detalles */}
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "14px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <h4
            style={{
              margin: "0 0 8px 0",
              fontSize: "0.8rem",
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Detalles
          </h4>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              fontSize: "0.85rem",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "8px",
            }}
          >
            <li>
              <strong>Estatura:</strong> {estatura}
            </li>
            <li>
              <strong>Cuerpo:</strong> {cuerpo}
            </li>
            <li>
              <strong>Cabello:</strong> {cabello}
            </li>
            <li>
              <strong>Horario:</strong> {horario}
            </li>
            <li style={{ gridColumn: "span 2" }}>
              <strong>Días:</strong> {dias}
            </li>
          </ul>
        </div>

        {/* Servicios */}
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "14px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <h4
            style={{
              margin: "0 0 8px 0",
              fontSize: "0.8rem",
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Servicios
          </h4>
          {serviciosArray.length > 0 ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {serviciosArray.map((s, idx) => (
                <span
                  key={idx}
                  style={{
                    background: "#f1f5f9",
                    color: "#334155",
                    padding: "5px 10px",
                    borderRadius: "8px",
                    fontSize: "0.78rem",
                    fontWeight: "500",
                  }}
                >
                  {s}
                </span>
              ))}
            </div>
          ) : (
            <p style={{ margin: 0, fontSize: "0.85rem", color: "#94a3b8" }}>
              Sin servicios especificados
            </p>
          )}
        </div>

        {/* Sobre mí */}
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "14px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <h4
            style={{
              margin: "0 0 6px 0",
              fontSize: "0.8rem",
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Sobre mí
          </h4>
          <p
            style={{
              fontSize: "0.85rem",
              color: "#334155",
              lineHeight: "1.4",
              margin: 0,
            }}
          >
            {descripcion}
          </p>
        </div>

        {/* Galerías de Miniaturas */}
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "14px",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          <h4
            style={{
              margin: "0 0 8px 0",
              fontSize: "0.8rem",
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Fotos ({fotos.length})
          </h4>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "6px",
            }}
          >
            {fotos.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt="Miniatura"
                onClick={() => {
                  setFotoActualIndex(idx);
                  setFotoModalIndex(idx);
                }}
                style={{
                  width: "100%",
                  aspectRatio: "1",
                  objectFit: "cover",
                  borderRadius: "6px",
                  cursor: "pointer",
                  border:
                    idx === fotoActualIndex
                      ? "2px solid #e11d48"
                      : "1px solid #e2e8f0",
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* 4. BOTÓN FLOTANTE FLOTANDO AL FINAL DEL CONTENEDOR */}
      {/* 4. BOTÓN FLOTANTE CON EFECTO ONDA */}
      <button onClick={alVolver} className="btn-flotante-volver">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>

      {/* 5. MODAL DE PANTALLA COMPLETA */}
      {fotoModalIndex !== null && (
        <div
          onClick={() => setFotoModalIndex(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.95)",
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px",
            boxSizing: "border-box",
          }}
        >
          <button
            onClick={() => setFotoModalIndex(null)}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: "2rem",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ✕
          </button>

          <img
            src={fotos[fotoModalIndex]}
            alt="Foto completa"
            style={{
              maxWidth: "100%",
              maxHeight: "90vh",
              objectFit: "contain",
              borderRadius: "8px",
            }}
          />
        </div>
      )}
    </div>
  );
}

export default DetalleRediseno;
